(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sessions', {
            parent: 'account',
            url: '/sessions',
            data: {
                authorities: ['ROLE_INSTRUMENT_COORDINATOR', 'ROLE_INSTRUMENT_TEAM_MEMBER', 'ROLE_USER', 'ROLE_POWER_USER', 'ROLE_PLAN_COORDINATOR', 'ROLE_ADMIN'],
                pageTitle: 'Sessions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/sessions/sessions.html',
                    controller: 'SessionsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
